import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Grid, Hidden, Paper, Typography } from '@mui/material';
import StepperManagement from '../components/stepperManagement';
import { makeStyles } from 'tss-react/mui';
import PropertyCard from '../components/propertyCard';
import BookingRecap from '../components/bookingRecap';
import { getReservationsByToken, getRoomTypeDetails } from '../../../../utils/requests';
import { AxiosResponse } from 'axios';
import { ModuleBookingManagementContext } from '../../../../pages/modules/ModuleBookingManagement';
import { getProperties } from '../../../../utils/helpers';
import { IAccommodationMoreInfo } from '../../../../interfaces/huWebsite';
import { AppContext } from '../../../../utils/appContext';

const Booking = () => {
  const bookingManagerContext = useContext(ModuleBookingManagementContext);

  const useStyles = makeStyles()((theme) => {
    return {
      bookingDetails: {
        b: {
          alignItems: 'center',
          fontFamily: theme.typography.h1.fontFamily,
          '& svg': {
            color: '#2357D0',
            fontSize: 16,
            marginRight: 5
          }
        },
        p: {
          fontFamily: theme.typography.body1.fontFamily
        }
      },
      total: {
        b: {
          fontFamily: theme.typography.h1.fontFamily
        }
      },
      ctaManagement: {
        fontSize: 16,
        fontFamily: theme.typography.h1.fontFamily
      },
      propertyCard: {
        h3: {
          fontSize: 28,
          fontFamily: theme.typography.h1.fontFamily
        },
        p: {
          fontSize: 16,
          fontFamily: theme.typography.body2.fontFamily,
          lineHeight: '26px'
        }
      },
      stepperContainer: {
        [theme.breakpoints.down('sm')]: {
          backgroundColor: '#f5f5f1'
        }
      }
    };
  });

  const { classes } = useStyles();
  const { t } = useTranslation();

  const [resDetails, setResDetails] = useState<any>({});

  useEffect(() => {
    getReservationsByToken()
      .then((response: AxiosResponse) => {
        setResDetails(response.data[0]);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [localStorage.getItem('token_bookings_management')]);

  const appContext = useContext(AppContext);
  const [roomTypeInfo, setRoomTypeInfo] = useState<IAccommodationMoreInfo>();
  const property = getProperties().find(
    (property) => property.code === appContext.searchForm[0].property
  );

  useEffect(() => {
    if (property) {
      getRoomTypeDetails({ url: property.room_info_end_point + resDetails.RoomType })
        .then((response: AxiosResponse<IAccommodationMoreInfo>) => {
          setRoomTypeInfo(response.data);
        })
        .catch();
    }
  }, [resDetails]);

  return (
    <Box mt={5} pt={2}>
      <Grid container direction={'row'} justifyContent={'center'} alignItems={'center'}>
        <Grid item md={11}>
          <Grid container direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
            <Grid item xs={12} sm={4} md={4} lg={3} className={classes.stepperContainer}>
              <StepperManagement step={1} />
            </Grid>
            <Grid item xs={10} sm={7} md={8} sx={{ margin: 'auto' }}>
              <Grid
                container
                direction={'row'}
                justifyContent={'space-between'}
                alignItems={'center'}>
                <Grid item md={5}>
                  <Hidden smUp>
                    <Box pt={5}>
                      <Typography variant={'h5'} component={'h5'}>
                        Riepilogo prenotazione
                      </Typography>
                      <Box mt={3}>
                        <Paper elevation={2}>
                          <img
                            src="/destination.png"
                            alt="image"
                            width={'100%'}
                            height={150}
                            style={{ objectFit: 'cover' }}
                          />
                          <Box p={2}>
                            <Typography variant={'h5'} component={'h5'}>
                              hu Park Albatros Village
                            </Typography>
                            <hr />
                            <BookingRecap reservation={resDetails} room={roomTypeInfo} />
                          </Box>
                        </Paper>
                      </Box>
                    </Box>
                  </Hidden>
                  <Hidden smDown>
                    <BookingRecap reservation={resDetails} room={roomTypeInfo} />
                  </Hidden>
                </Grid>
                <Hidden mdDown>
                  <Grid item md={5}>
                    <PropertyCard reservation={resDetails} room={roomTypeInfo} />
                  </Grid>
                </Hidden>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Booking;
